import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { EquipmentOptionView } from "./list/EquipmentOptionView"
import type { GetEquipmentListQueryParams } from "./list/GetEquipmentListQueryParams"

export const getEquipmentListRoute: ApiRoute<NoPathParams, GetEquipmentListQueryParams, NoBody, EquipmentOptionView[]> =
	{
		buildUrl: () => "/equipment/list",
		method: "get",
		path: "/equipment/list",
	}
